import React from 'react'
import SharedFilters from '../../../components/SharedFilters'
import useFeedbackList from './hooks/useFeedbackList'
import FeedbackTable from './components/FeedbackTable'
import AppPagination from '../../../components/AppPagination'

export default function FeedbackListScreen() {
  const { state, actions } = useFeedbackList()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Header ── */}
      <section className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Inquiries
          </p>
          <div className="flex items-center gap-3 mt-1">
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
              Feedback/Queries
            </h1>
            <span className="rounded-xl bg-surface-container-high px-3 py-1 text-xs font-bold text-on-surface-variant">
              {state.totalCount} entries
            </span>
          </div>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            View student suggestions, inquiries, and issues submitted via mobile app &amp; portal, and manage administrative replies.
          </p>
        </div>
      </section>

      {/* ── Filter Accordion ── */}
      <SharedFilters
        // Accordion Selection
        visibleAccordionFilters={[
          'company',
          'branch',
          'course',
          'batch',
          'type',
          'period',
          'fromDate',
          'tillDate',
        ]}
        // Company / Institute
        companyFilter={state.companyFilter}
        setCompanyFilter={actions.setCompanyFilter}
        companyOptions={state.options.companies}
        // Branch
        branchFilter={state.branchFilter}
        setBranchFilter={actions.setBranchFilter}
        branchOptions={state.options.branches}
        // Course
        courseFilter={state.courseFilter}
        setCourseFilter={actions.setCourseFilter}
        courseOptions={state.options.courses}
        // Batch
        batchFilter={state.batchFilter}
        setBatchFilter={actions.setBatchFilter}
        batchOptions={state.options.batches}
        // Type
        typeFilter={state.typeFilter}
        setTypeFilter={actions.setTypeFilter}
        typeOptions={state.options.types}
        // Period
        periodFilter={state.periodFilter}
        setPeriodFilter={actions.setPeriodFilter}
        periodOptions={state.options.periods}
        // Date Range
        fromDate={state.fromDate}
        setFromDate={actions.setFromDate}
        tillDate={state.tillDate}
        setTillDate={actions.setTillDate}
        // Search & Reset
        searchText={state.searchText}
        setSearchText={actions.setSearchText}
        onReset={actions.handleResetFilters}
        onSearch={actions.loadData}
        showStatus={false}
      />

      {/* ── Feedback Table & Pagination Wrapper ── */}
      <div className="flex flex-col gap-4">
        <FeedbackTable
          records={state.pagedRecords}
          loading={state.loading}
        />

        {state.totalCount > 0 && (
          <div className="flex flex-col gap-3 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-6 py-4 sm:flex-row sm:items-center sm:justify-between shadow-xs">
            <span className="text-xs font-medium text-on-surface-variant">
              Showing {state.rangeStart} to {state.rangeEnd} of {state.totalCount} entries
            </span>

            <AppPagination
              page={state.page}
              totalPages={state.totalPages}
              onPageChange={actions.setPage}
              onPrevious={actions.goToPreviousPage}
              onNext={actions.goToNextPage}
              canPrevious={state.page > 1}
              canNext={state.page < state.totalPages}
            />
          </div>
        )}
      </div>
    </div>
  )
}
